var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_9322",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 9322",
    transform: "translate(10814 10322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3990",
    "data-name": "\\u9577\\u65B9\\u5F62 3990",
    width: 64,
    height: 64,
    transform: "translate(-10814 -10322)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_9321",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 9321",
    transform: "translate(44 45.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3989",
    "data-name": "\\u9577\\u65B9\\u5F62 3989",
    width: 40,
    height: 40,
    transform: "translate(-10846 -10355)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1562",
    "data-name": "\\u30D1\\u30B9 1562",
    d: "M-126.215,130.366l20,20-20,20",
    transform: "translate(-10709.285 -10485.866)",
    fill: "none",
    stroke: "#4ea9cd",
    strokeLinecap: "round",
    strokeWidth: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrowRight);
export default __webpack_public_path__ + "static/media/icons_arrow_right.d5f4e517ef551d2acd28acd8ffde3788.svg";
export { ForwardRef as ReactComponent };